import { ReactNode, useEffect } from "react";
import { useLayoutContext } from "./Layout";

interface PageWithTitleProps {
  title: string;
  children: ReactNode;
}

const PageWithTitle = ({ title, children }: PageWithTitleProps) => {
  const context = useLayoutContext();

  useEffect(() => {
    if (context?.setHeaderTitle) {
      context.setHeaderTitle(title);
    }
  }, [context, title]);

  return <>{children}</>;
};

export default PageWithTitle;
